import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { tasks as tasksApi } from 'redux/modules/api'
import { combineAnd } from 'utils/apiFilter'

function decorator (config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api, auth, app }) => ({
        tasksAwardSignoff: api.tasks.awardSignoff,
        user: auth.user,
        commonLimit: app.commonLimit
      }),
      { ...tasksApi.awardSignoff }
    )
    class TasksAwardSignoff extends Component {
      static propTypes = {
        decoFilter: PropTypes.string,
        decoFilterMyOnly: PropTypes.bool,
        tasks: PropTypes.object,
        tasksAwardSignoff: PropTypes.object,
        getTasksAwardSignoff: PropTypes.func,
        exportAwardOfficeTasks: PropTypes.func,
        exportAwardOfficeLocallyTasks: PropTypes.func,
        resetTasksAwardOffice: PropTypes.func,
        getTasksAwardOfficeSignoffLocally: PropTypes.func,
        getTasksAwardOfficeSignoff: PropTypes.func,
        setOfficeParams: PropTypes.func,
        commonLimit: PropTypes.number,
        setUnitParams: PropTypes.func,
        user: PropTypes.object
      }

      defaultProps = {
        tasks: {}
      }

      componentDidMount () {
        const { tasksAwardSignoff, decoFilterMyOnly, commonLimit, setUnitParams, setOfficeParams } = this.props

        if (config.useCommonLimit && commonLimit) {
          config.unit && setUnitParams({ limit: commonLimit })
          config.office && setOfficeParams({ limit: commonLimit })
        } else {
          config.unit && this.handleGetTasksAwardSignoff(tasksAwardSignoff.unit, decoFilterMyOnly)
          config.office &&
          this.handleGetTasksOfficeAwardSignoff(
            tasksAwardSignoff.office,
            this.handleGetOfficeBaseFilter()
          )
          config.officeLocally && this.handleGetTasksOfficeAwardSignoffLocally()
        }
      }

      componentWillReceiveProps (nextProps) {
        const {
          tasksAwardSignoff: { unit, office },
          decoFilterMyOnly
        } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.tasksAwardSignoff.unit
        const {
          filter: filterOffice,
          limit: limitOffice,
          offset: offsetOffice,
          sort: sortOffice,
          invalidate: invalidateOffice,
        } = nextProps.tasksAwardSignoff.office

        if (
          unit.filter !== filter ||
          unit.limit !== limit ||
          unit.offset !== offset ||
          unit.sort !== sort ||
          unit.invalidate !== invalidate ||
          decoFilterMyOnly !== nextProps.decoFilterMyOnly
        ) {
          config.unit &&
          this.handleGetTasksAwardSignoff(nextProps.tasksAwardSignoff.unit, nextProps.decoFilterMyOnly)
        }

        if (
          office.filter !== filterOffice ||
          office.limit !== limitOffice ||
          office.offset !== offsetOffice ||
          office.sort !== sortOffice ||
          office.invalidate !== invalidateOffice
        ) {
          config.office &&
          this.handleGetTasksOfficeAwardSignoff(
            nextProps.tasksAwardSignoff.office,
            this.handleGetOfficeBaseFilter()
          )

          config.officeLocally &&
          this.handleGetTasksOfficeAwardSignoffLocally(
            nextProps.tasksAwardSignoff.office,
            this.handleGetOfficeBaseFilter()
          )
        }
      }

      componentWillUnmount = () => {
        this.props.resetTasksAwardOffice()
      }

      handleGetTasksAwardSignoff = (tasks, myOnly) => {
        const personId = this.props.user.personId
        const filterMyOnly = myOnly || this.props.decoFilterMyOnly
        const combinedFilter = combineAnd(tasks.filter,
          filterMyOnly
            ? `award.awardLeader.person.id=${personId}`
            : '')

        return this.props.getTasksAwardSignoff({ ...tasks, filter: combinedFilter })
      }

      handleGetTasksOfficeAwardSignoff = (tasks, baseFilter) =>
        this.props.getTasksAwardOfficeSignoff(tasks, baseFilter)

      handleGetTasksOfficeAwardSignoffLocally = (tasks, baseFilter) =>
        this.props.getTasksAwardOfficeSignoffLocally(tasks, baseFilter)

      handleGetOfficeBaseFilter = () => {
        const { decoFilter, params } = this.props

        switch (decoFilter || config.filter) {
          case 'organizationAwards':
            return `organization.flatHierarchy.parentOrganization.id=${
              params.id
            }`
          default:
            return ''
        }
      }

      handleExportAwardOfficeTasks = () => {
        const { tasksAwardSignoff } = this.props

        return this.props
          .exportAwardOfficeTasks(
            tasksAwardSignoff.office,
            this.handleGetOfficeBaseFilter()
          )
          .catch(this.handleError)
      }

      handleExportAwardOfficeLocallyTasks = () => {
        const { tasksAwardSignoff } = this.props

        return this.props
          .exportAwardOfficeLocallyTasks(
            tasksAwardSignoff.office,
            this.handleGetOfficeBaseFilter()
          )
          .catch(this.handleError)
      }

      render () {
        return (
          <ComposedComponent
            {...this.props}
            tasks={{ ...this.props.tasks, ...this.props.tasksAwardSignoff }}
            exportAwardOfficeTasks={this.handleExportAwardOfficeTasks}
            exportAwardOfficeLocallyTasks={
              this.handleExportAwardOfficeLocallyTasks
            }
          />
        )
      }
    }

    return TasksAwardSignoff
  }
}

export default decorator
